import { Outlet } from "react-router-dom";
import { LoadingOverlay } from "@mantine/core";
import { useAuth } from "@/hooks/useAuth";
import LoggedInCompanyWorkspaceRedirect from "@/routes/LoggedInCompanyWorkspaceRedirect";

/**
 * Shared public discover URL (`/discover/:companyId`) from admin copy-link, email, etc.
 * Guests see the anonymous discover profile; logged-in users go to the collaboration workspace.
 */
export function DiscoverCompanyProfileGate() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingOverlay visible={true} />;
  }

  if (isAuthenticated) {
    return <LoggedInCompanyWorkspaceRedirect />;
  }

  return <Outlet />;
}
